import React, { useContext, useEffect, useState, Fragment } from "react";
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom'; 
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import { BaseUrl } from "../../../contexts/baseUrl/baseUrl";
import Layout from "../../sales/layout/layout";
import axios from "services/interceptor/Interceptor";
import {toast} from "react-toastify";
import Images from "../../../assets/images/imageData";
import ListFilters from "../../sales/ListFilters/ListFilters";


const UserConfigListing = ({
    userConfigListing,
    helpdeskListDetails = [],
    userconfigurationStatus,
                                 userconfigstatusDetails = [],
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const { baseUrl } = useContext(BaseUrl);
    const [listData, setListData] = useState([]);
    const history = useHistory();
    const [showFilter, setShowFilter] = useState(false);
    const [filterData, setFilterData] = useState(null);
    const [page, setPage] = useState(1);

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const getFilter = await JSON.parse(
                localStorage.getItem("help_desk_users")
            );
            if(getFilter !== {}){
                await userConfigListing(1, getFilter)
            }else{
                await userConfigListing()
            }
            setIsLoading(false);
        })();
    }, []);

    const headers = [
        'Username',
        'First Approver Name',
        'Second Approver Name',
        'Status',
        'Action',
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await userConfigListing(val.selected + 1, filterData);
        setIsLoading(false);
    };

    const callUserConfigStatus = async (data) => {
        setIsLoading(true)
        await userconfigurationStatus({
            id:data?.id,
            status:data?.check === true ? 1 : 2
        })
        setIsLoading(false)
    };


    useEffect(() => {
        if(userconfigstatusDetails?.status !== undefined){
            if(parseInt(userconfigstatusDetails?.status) === 200){
                toast.success(userconfigstatusDetails?.message)
                setTimeout(() => {
                    window.location.reload()
                }, 150)

            }else if(parseInt(userconfigstatusDetails?.status) === 400){
                toast.warning(userconfigstatusDetails?.message)
            }
        }
    }, [userconfigstatusDetails])


    useEffect(() => {
        if (helpdeskListDetails && helpdeskListDetails.data && helpdeskListDetails.data.length > 0) {
            const tableData = ['id', 'user_name', 'a1_approver_name', 'a2_approver_name', 'status', 'Action'];

            const data = helpdeskListDetails.data.map((element) => {
                const extractedData = {};

                tableData.forEach((key) => {
                    if (key === 'user_name') {
                        extractedData[key] = `${element[key]} (${element.user_email})`;
                    } else if (key === 'a1_approver_name') {
                        extractedData[key] = `${element[key]} (${element.a1_approver_email})`;
                    } else if (key === 'a2_approver_name') {
                        extractedData[key] = `${element[key]} (${element.a2_approver_email})`;
                    } 
                    // else if (key === 'Action') {
                    //     extractedData[key] = [
                    //         { name: 'Edit', link: `${baseUrl}/edit-user-config` }
                    //     ];
                    // } 
                    else {
                        extractedData[key] = element[key];
                    }
                });

                return extractedData;
            });


            setListData(data);
            setPageCount(Math.ceil(helpdeskListDetails.total / helpdeskListDetails.per_page));
        }
    }, [helpdeskListDetails]);

    const filterToggle = () => {
        setShowFilter(!showFilter);
    };

    const applyFilter = async (filterData) => {
        localStorage.setItem("help_desk_users", JSON.stringify(filterData));
        setIsLoading(true);
        setFilterData(filterData);
        setListData([])
        await userConfigListing(1, filterData);
        setIsLoading(false);
        filterToggle();
    };

    const headerBtns = () => {
        return (
            <Fragment>
                <Button
                    onClick={() => {
                        history.push(`${baseUrl}/add-user-config`);
                    }}
                    className="filter-hamburger btn btn-transparent"
                >
                   Add {localization.configuration}
                </Button>
                <Button
                    onClick={filterToggle}
                    className="filter-hamburger show-btn btn btn-transparent"
                >
                    {' '}
                    <img src={Images?.Filter} alt="" />
                    {localization.showFilters}
                </Button>
            </Fragment>
        );
    };

    return (
        <>
            <Layout
                title={`Configuration List`}
                isLoading={isLoading}
                Buttons={headerBtns}
                // isGoback={true}
            >
                <TableSection
                    data={listData}
                    isId={false}
                    isMngId={false}
                    headers={headers}
                    pageCount={pageCount}
                    onPageChange={onPageChange}
                    detailList={helpdeskListDetails?.data?.data}
                    srNo={helpdeskListDetails?.from}
                    helpdeskStatus={callUserConfigStatus}
                />
                <ListFilters
                    showFilter={showFilter}
                    filterToggle={filterToggle}
                    applyFilter={(val) => applyFilter(val)}
                    helpdeskUserFilter={true}
                    localstorageKey={'help_desk_users'}
                />
            </Layout>
        </>
    )
}

export default UserConfigListing;
